/** Checkout verification: where it applies (cart / line items). Stored on `checkout.target`. */

export const CHECKOUT_TARGET_CHOICES = [
  {
    label: "Always",
    value: "always",
    helpText: "Run checkout verification for every checkout. No collection or product filter.",
  },
  {
    label: "Specific collection",
    value: "collections",
    helpText: "Only when the cart includes a product from one of the selected collections.",
  },
  {
    label: "Specific product",
    value: "products",
    helpText: "Only when the cart includes one of the selected products.",
  },
];

function splitHandles(s) {
  return String(s || "")
    .split(/[,\n]+/)
    .map((x) => x.trim())
    .filter(Boolean);
}

export function normalizeCheckoutTarget(raw) {
  const base = {
    mode: "always",
    selectedProducts: [],
    selectedCollections: [],
    productHandles: "",
    collectionHandles: "",
  };
  const t = { ...base, ...(raw && typeof raw === "object" ? raw : {}) };
  const m = String(t.mode || "always").toLowerCase();
  if (m === "collections" || m === "collection") t.mode = "collections";
  else if (m === "products" || m === "product") t.mode = "products";
  else t.mode = "always";

  t.selectedProducts = Array.isArray(t.selectedProducts) ? [...t.selectedProducts] : [];
  t.selectedCollections = Array.isArray(t.selectedCollections) ? [...t.selectedCollections] : [];

  if (t.mode === "products" && t.selectedProducts.length === 0 && t.productHandles) {
    t.selectedProducts = splitHandles(t.productHandles).map((handle) => ({ handle }));
  }
  if (t.mode === "collections" && t.selectedCollections.length === 0 && t.collectionHandles) {
    t.selectedCollections = splitHandles(t.collectionHandles).map((handle) => ({ handle }));
  }

  return t;
}
